module.exports = __webpack_public_path__ + "static/8a4257937ac59725773a1b9b13536f6734db541bb8cfc23e5bf4e64c8cedf32c-581ec53d7f2baef74fa4a64ec3b1db50.png";